/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Dialog} from "../../models/dialog";
import { EmGroup } from '../../models/em-group';
import { GroupType } from '../../models/group-type';

import { DialogService } from "../../services/dialog.service";
import { GroupService } from '../../services/group.service';

import {OnInit, Component, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";


import { PagedResults } from "app/models/paged-results";
import { RESULTS_PER_PAGE } from "app/app-constants";
import { Rule } from "app/models/rule";

@Component({
  templateUrl: './dialogs.component.html',
  styleUrls: ['../../../assets/css/infrastructure.css']
})
export class DialogsComponent implements OnInit {

  //Dialogs shown in the UI
  mDialogs: Dialog[] = [];
  selectedDialogs: DialogUI[] = [];

  filterColumnDialog = null;
  filterColumnNameDialog = "";
  filterStringDialog = "";

  // paginator variables
  //pageSize = 2;
  numberOfDialogs = 0;
  totalNumberOfDialogs = 0;
  currentPageForDialogs = 1;

  // List for Dropdown of Results Per Page value
  resultsPerPageValues = RESULTS_PER_PAGE;
  selectedPageSizeValueForDialogs: number = this.resultsPerPageValues[0];


  constructor(
    private mRoute: ActivatedRoute,
    private mRouter: Router,
    private mDialogsService: DialogService
  ) {}

   ngOnInit() {
    //Subscribe to the Route to get the Dialogs that get loaded as it is resolved
    this.mRoute.data.subscribe((data: {dialogs: PagedResults<Dialog>}) => {
      this.selectedDialogs = [];

      //Set the initial values for Pagination
      this.selectedPageSizeValueForDialogs = this.resultsPerPageValues[0];


      for (const dialog of data.dialogs.data) {
        const dialogUI = new DialogUI();
        dialogUI.dialog = dialog;
        this.selectedDialogs.push(dialogUI);
      }
      //Set the total Number of Dialogs. Earlier the size was set based only to the count of dialogs for one page.
      this.totalNumberOfDialogs = data.dialogs.size;
    });
  }

  manageResultPerPageClickedForDialogs(value: number): void {
    this.selectedPageSizeValueForDialogs = value;
    // selecting any value will bring you back to first page
    this.currentPageForDialogs = 1;
    this.refreshDialogs();
  }

  private async refreshDialogs(): Promise<void> {
    await this.mDialogsService.getAllDialogsForPaging((this.currentPageForDialogs - 1) * this.selectedPageSizeValueForDialogs, this.selectedPageSizeValueForDialogs, 'ASC', this.filterStringDialog).then(
       responses => {
        this.selectedDialogs = [];
        for(const response of responses.data) {
          const dialogUI = new DialogUI();
          dialogUI.dialog = response;
          this.selectedDialogs.push(dialogUI);
        }
        this.totalNumberOfDialogs = responses.size;
      },
      error => {
        console.log("Error calling getAllDialogsForPaging");
      }
    );
  }

  deleteSelectedDialogsClicked(): void {
    console.log("deleteSelectedDialogsClicked() - Selected Dialogs: ", this.getSelectedDialogs());
    const selectedDialogs = this.getSelectedDialogs();
    if (selectedDialogs.length > 0) {
      selectedDialogs.forEach(dialog => this._deleteDialog(dialog));
    }
  }

  deleteDialog(dialog: Dialog): void {
    console.log("deleteDialog() - Dialog: " + (dialog == null ? "*NULL*" : (dialog.id + "/" + dialog.name)));
    this._deleteDialog(dialog);
  }

  private async _deleteDialog(dialog: Dialog): Promise<void> {
    try {
      await this.mDialogsService.deleteDialog(dialog.id);
      const index = this.mDialogs.indexOf(dialog);
      if (index > -1) {
        this.mDialogs.splice(index, 1);
      }
    } catch (error) {
      this.handleError(error);
    }

    this.refreshDialogs();
  }

  handleError(error: any): void {
    console.error("handleError() - Error: " + error);
    if ( error?.error != null) {
      alert(error.error);
    }
    else if (error != null) {
      const response: Response = error;
      alert(response.text());
    }
  }

async getRulesUsingDialog(dialog: Dialog): Promise<Rule[]> {
    console.log("getRulesUsingDialog() - Dialog: " + (dialog == null ? "*NULL*" : (dialog.id + "/" + dialog.name)));
     await this.mDialogsService.getRulesUsingDialog(dialog).then(
    response => {
      console.log("getRulesUsingDialog() - Response: ", response);
      if (response != null && response.length > 0) {
        //this.handleError("This dialog is used in the following rules: " + response.map(rule => rule.name).join(", "));
        console.log("Rules using dialog: ", response);
        return response;
      } else {
        return [];
      }
    },
    error => {
      console.error("Error getting Rules using dialog: ", error);
    }
  );
    return [];
}

  isEmptySelection(): boolean {
    return this.selectedDialogs.filter(dialog => dialog.selected).length == 0;
  }

  isAllSelected(): boolean {
    return this.selectedDialogs.every(dialog => dialog.selected);
  }

  selectAll(event: any): void {
    this.selectedDialogs.forEach(dialog => dialog.selected = event.target.checked);
  }

  getSelectedDialogs(): Dialog[] {
    const dialogs: Dialog[] = [];
    this.selectedDialogs.filter(ui => ui.selected).forEach(ui => dialogs.push(ui.dialog));
    return dialogs;
  }

  getSelectedIds(): number[] {
    const ids: number[] = [];
    this.selectedDialogs.filter(ui => ui.selected).forEach(ui => ids.push(ui.dialog.id));
    return ids;
  }

  getSelectedNames(): string[] {
    const names: string[] = [];
    this.selectedDialogs.filter(ui => ui.selected).forEach(ui => names.push(ui.dialog.name));

    return names;
  }

  pageChanged(pageNumber: number): void {
    if(pageNumber == null || pageNumber == undefined || pageNumber < 1) {
      return;
    }
    if (this.currentPageForDialogs == pageNumber) {
      return;
    }
    this.currentPageForDialogs = pageNumber;
    this.refreshDialogs();
  }

  setFilterDialog(filterColumnName: string, filterColumn: string): void {
    this.filterColumnDialog = filterColumn;
    this.filterColumnNameDialog = filterColumnName;
    if (!this.filterColumnDialog) {
      this.filterStringDialog = "";
    }
    this.filterStringChangedDialog(1);
  }


  filterStringChangedDialog(pageNumber?: number): void {
    if (!pageNumber) { pageNumber = 1; }
    // Show only size on this new page
    console.log("page Changed to " + pageNumber);
    this.currentPageForDialogs = pageNumber;

    this.refreshDialogs();

  }


}

class DialogUI {
    selected = false;
    dialog: Dialog;
}
